// import { StrictMode } from 'react';
import { registerDayjsPlugins } from '@infield/utils/dayjsPlugins';
import { createRoot } from 'react-dom/client';

import App from './app';

registerDayjsPlugins();
const root = createRoot(document.getElementById('root')!);
root.render(<App />);
